module.exports = __webpack_public_path__ + "img/guard_of_rileys_subconscious.58caeeb0.jpg";